import { render } from "./App.vue?vue&type=template&id=60aa5811"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=60aa5811&lang=css"
script.render = render

export default script